
import { FirearmAssignmentLogMetadataBase } from './firearm-assignment-log.metadata.base';


export class FirearmAssignmentLogMetadata extends FirearmAssignmentLogMetadataBase {
  constructor() {
    super();
  }
}

export const FIREARM_ASSIGNMENT_LOG_METADATA: FirearmAssignmentLogMetadata = new FirearmAssignmentLogMetadata();


